import './index.scss'
import { clippathList } from './optionlist.js'

import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { InspectorControls } from '@wordpress/block-editor';
import { createHigherOrderComponent } from '@wordpress/compose';
import classnames from 'classnames'
import { PanelBody,	SelectControl, TextControl } from '@wordpress/components';



const allowedBlocks = [ 'core/cover', 'core/image' ];

const addAttributes = ( settings, name ) => {
    
    if ( ! allowedBlocks.includes( name ) ) {
        return settings;
    }

    //console.log(settings)

    return Object.assign( {}, settings, {
        attributes: Object.assign( {}, settings.attributes, {
            clippath: { type: 'string' },               
            customclippath: { type: 'string' }
        } ),
    } );
};


const addInspectorControl = createHigherOrderComponent( ( BlockEdit ) => {
    return ( props ) => {
     
    	if ( ! allowedBlocks.includes( props.name ) ) {
            return (
                <BlockEdit { ...props } />
            );
        }

        const { attributes, setAttributes } = props;
        const { clippath, customclippath } = attributes;

        return (
            <>
                <BlockEdit { ...props } />
                    <InspectorControls>
                	    <PanelBody title={ __( 'Clip Path' ) } initialOpen={false}>
                            <SelectControl
                                label={ __( 'Clip Path Option', 'aver' ) }
                                options={ clippathList }
                                value={ clippath }
                                onChange={ ( newvalue ) => {
                                    setAttributes( { clippath: newvalue } );						
                                }	}
                            />                                         

                            { clippath == 'custom' && <TextControl
                                label={ __( 'Other Clip Path', 'aver' ) }
                                value={ customclippath }
                                onChange={ (newval) => setAttributes({customclippath: newval}) }						
                            />}
	                    
	                    </PanelBody>
                    </InspectorControls>
            </>
        );
    };
}, 'addInspectorControl' );




const applyExtraClassEditor = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {

      
        if ( ! allowedBlocks.includes( props.name ) ) {
            return (
                <BlockListBlock { ...props } />
            );
        }

        const { attributes, wrapperProps, className } = props;
        const { clippath, customclippath } = attributes;

        if ( clippath === '') {
			return (
                <BlockListBlock { ...props } />
            );
		}


     

		const cssstyle = { 
			...wrapperProps?.style,
            ...( customclippath && clippath == 'custom' && { clipPath: customclippath }  )
		}        
        

        const classes = classnames(
            className, ``, 
            { 
                [ `has-option-${clippath}`]: ( typeof clippath !== 'undefined' && clippath != '' && clippath != 'custom' ),                
                               
            }
        );
      

        return <BlockListBlock { ...props }        
            wrapperProps={ { style : cssstyle } } 			
            className={ classes } 			
        />
        
    };
}, 'applyExtraClassEditor' );



const applyExtraClassSave = ( extraProps, blockType, attributes ) => {
   
    if ( ! allowedBlocks.includes( blockType.name ) ) {
         return extraProps;
    }

        const { clippath, customclippath } = attributes;

        const { className, style } = extraProps;	

        const classes = classnames(
            className, ``,
            { 
              [ `has-option-${clippath}`]: ( typeof clippath !== 'undefined' && clippath != '' && clippath != 'custom' ),                                             
            }
        );

        let cssstyle = { ...style }
        cssstyle = ( customclippath && clippath == 'custom' )? {...cssstyle, clipPath: customclippath } : { ...cssstyle }
        

    return {
        ...extraProps,
        style: cssstyle,
        className: classes
    }   

}


addFilter(
    'blocks.registerBlockType',
    'aver/cover-attributes',
    addAttributes
);


addFilter(
    'editor.BlockEdit',
    'aver/cover-advanced-control',
    addInspectorControl
);


addFilter(
    'editor.BlockListBlock',
    'aver/cover-editor-class',
    applyExtraClassEditor
);


//addFilter( 'blocks.getSaveContent.extraProps',  'aver/cover-save-class',  applyExtraClassSave );


